import { Typography } from '@navi/web-ui/lib/primitives';
import KeyValue from '../KeyValue';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';
import { ActivityLogsType, IActivityLogs } from '../../types';

const RcaDetails = () => {
  const rcaDetails =
    useSelector((state: RootState) => state?.anomalyTracker?.acitvityLogs?.data) || [];
  const { details } =
    rcaDetails?.find((rca: IActivityLogs) => rca?.type === ActivityLogsType.RCA) || {};

  if (!details) return null;

  return (
    <div>
      <Typography color="var(--grayscale-2)" variant="h3" className="mb-4 mt-5">
        RCA details
      </Typography>
      <KeyValue title="Name" description={details?.name} />
      <KeyValue
        title="Date"
        description={
          details?.at ? dayjs(details?.at)?.format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME) : null
        }
      />
      <KeyValue title="Type" description={details?.reason} />
      <KeyValue title="Comments" description={details?.comment ? details?.comment : null} />
    </div>
  );
};

export default RcaDetails;
